import { createSelector, Selector } from 'reselect'

import { PaymentsState } from '../model/billing.model'

import { RootState } from '~/core/store/root.reducer'

type GetPayments = Selector<RootState, PaymentsState>

export const getPayments: GetPayments = (state) => state.payments

export const selectIban = createSelector(getPayments, (payments) => payments.iban)
export const selectBillingForm = createSelector(getPayments, (payments) => ({
  ...payments,
  iban: payments.iban.value,
}))

export const selectPaymentAddress = createSelector(getPayments, (payments) => payments.address)

export const selectContractDestination = createSelector(
  getPayments,
  (payments) => payments.contractDestination,
)
